import { Injectable } from '@angular/core';
import { LocationService } from '../../../../../../data-services/location.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataFilterDisplayService } from '../../interface';

@Injectable({ providedIn: 'root' })
export class CountryOptionsDisplayService implements DataFilterDisplayService {
  countryOptions$ = this.countriesService.getCountries();
  constructor(private countriesService: LocationService) {}

  getDisplay(value: string): Observable<string> {
    return this.countryOptions$.pipe(
      map((countries) => countries.find((c) => c.code === value)),
      map((country) => `<b>${country?.name}</b>`),
    );
  }
}
